import { Box } from "@mui/material";

export const Error403: React.FunctionComponent = () => {
  return (
    <Box sx={{ p: 2 }}>Sorry, you don't have permission to view this page.</Box>
  );
};
